import { SxProps } from "@mui/material";
import { palette } from "theme";
import { TabsVariant } from "./types";

export const tabListSxMap: Record<TabsVariant, SxProps> = {
  standard: {},
  redesign: {
    position: "relative",
    borderBottom: `1px solid ${palette.base[100]}`,
  },
};

export const tabSxMap: Record<TabsVariant, SxProps> = {
  standard: {
    py: 0.5,
  },
  redesign: {
    py: 1,
    backgroundColor: "transparent",
    fontWeight: 500,
    color: palette.text.secondary,
    borderBottom: "4px solid transparent",
    "&.Mui-selected": {
      backgroundColor: "transparent",
      borderColor: palette.primary.main,
      color: palette.primary.main,
    },
  },
};

export const tabPanelSxMap: Record<TabsVariant, SxProps> = {
  standard: {
    "& > div": {
      backgroundColor: "white",
      borderRadius: 2,
      px: 2.5,
      width: "100%",
    },
  },
  redesign: {
    "& > div": {
      width: "100%",
    },
  },
};
